export const rootRouteId = '__root__'
export type RootRouteId = typeof rootRouteId
